import React, { Component } from 'react'
import { ChromePicker } from 'react-color'
import { getBoundingClientRect } from '../../utils/functions'

import FixedView from '../FixedView'

class AdvancedColorInput extends Component {

    state = {
        top: 0,
        left: 0,
        right: 0,
        opacity: 0,
        current: 'background',
    }

    handleClick = () => {
        this.setState({ opened: true })
        this.colorPicker.showView()
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleOpen = () => {
        this.setState({ displayColorPicker: true })
    }

    componentWillUnmount() {
        this.hideView()
    }

    callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                this.hideView()
            }
        })
    }

    checkHide = (e) => {
        if (e && this.view && !this.view.contains(e.target)) {
            this.hideView()
        }
    }

    hideView = () => {
        if (this.observer) {
            this.observer.disconnect()
        }
        clearInterval(this.interval)
        window.removeEventListener('mouseup', this.hideView)
        window.removeEventListener('scroll', this.getBounding, true);
        if (this.props.onHide && this.state.isOpen == true) {
            this.props.onHide()
        }
        this.setState({ opacity: 0 }, () => {
            this.setState({ isOpen: false })
        })
    }

    getBounding = () => {
        if (this.props.nodeRef && this.view) {
            let topOffset = this.props.topOffset ?? 35
            let bottomOffset = this.props.bottomOffset ?? 0
            let rect = getBoundingClientRect(this.props.nodeRef)
            let indicatorBound = getBoundingClientRect(this.positionIndicator)
            let windowTop = 0
            let spaceFromBottom = window.innerHeight - rect.bottom - windowTop - topOffset
            this.setState({ width: rect.width })
            let spaceFromTop = rect.top + windowTop
            let top = rect.bottom - indicatorBound.top
            let left = rect.left - indicatorBound.left
            let maxHeight = this.props.maxHeight ?? 300
            let optimized = false
            if (this.content) {
                let contentBound = getBoundingClientRect(this.content)
                maxHeight = contentBound.height
                optimized = true
            }
            if (spaceFromBottom < maxHeight) {
                if (spaceFromBottom < spaceFromTop) {
                    maxHeight = spaceFromTop > maxHeight ? maxHeight : (spaceFromTop - 10)
                    top = top - bottomOffset - maxHeight - 8
                } else {
                    top = top + topOffset
                    maxHeight = spaceFromBottom - 10
                }
            } else {
                top = top + topOffset
            }
            if (this.props.rightAlign && this.content) {
                let viewBound = getBoundingClientRect(this.content)
                left = left - viewBound.width + 30 + (this.props.xOffset ?? 0)
            } else {
                left = left - 10 - (this.props.xOffset ?? 0)
            }
            this.setState({ top: top, left: left, maxHeight }, () => {
                if (!this.state.isOpen) {
                    this.setState({ isOpen: true }, () => {
                        this.setState({ opacity: 1 }, () => {
                            if (!this.optimized) {
                                this.getBounding()
                            }
                        })
                    })
                }
            })
        }
    }

    handleChange = (e) => {
        let color = e.hex
        if (color != 'transparent') {
            color = color + Math.round(e.rgb.a * 255).toString(16)
        }
        let data = this.props.data ?? {}
        data[this.state.current] = color
        this.props.changeValue(this.props.header.key, data, this.props.extra,)
    }

    chooseFontColor(rawcolor) {
        let color = "#fff"
        if (rawcolor) {
            if (isNaN(Number(rawcolor[1])) || isNaN(Number(rawcolor[3])) || isNaN(Number(rawcolor[5]))) {
                color = "#000"
            }
            if (!isNaN(Number(rawcolor[7])) && Number(rawcolor[7]) < 6) {
                color = "#000"
            }
        }
        return color
    }

    render() {
        return (
            <div className='' style={{ zIndex: this.props.zIndex ?? null, }}>
                <div ref={el => this.currentNode = el} className="w-100 h-100 flexc" >
                    <button onClick={this.handleClick} className={"flexcc p-0 text-start"} style={{ minHeight: '20px', width: '100%', }}>
                        {this.props.data ? (
                            <div className='flexc w-100'>
                                <div className='mrd-2'>
                                    <div className='flexcc px-2' style={{ backgroundColor: this.props.data.background ?? '#fff', color: this.props.data.text ?? '#000', border: '1px solid #eee', height: 26, minWidth: 26, borderRadius: 6 }}>
                                        <p className='text-smaller text-semibold' style={{ lineHeight: 1 }}>{("Preview")}</p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <p className='placeholder w-100' >{(this.props.header?.information?.placeholder ?? ('Choose ...'))}</p>
                        )}
                    </button>
                </div >
                {this.state.opened && (
                    <div style={{ position: 'fixed', top: 0, left: 0, height: '100vh', width: this.props.width, }}>
                    </div>
                )}
                <div ref={el => this.view = el} className="" style={{}}>
                    <FixedView onHide={() => this.setState({ opened: false })} ref={(el) => (this.colorPicker = el)} nodeRef={this.currentNode} showFocus={false} zIndex={10} topOffset={5} xOffset={-10} bottomOffset={30} width={225}>
                        <>
                            <div className='w-100 br-8' ref={el => this.content = el} style={{ border: '1px solid #eee', pointerEvents: 'all', background: '#fff', fontSize: '10px' }}>
                                <div className='w-100 pt-2  ' style={{}}>
                                    <div className='flexc w-100 mb-1 px-2' style={{ userSelect: 'none' }}>
                                        <div className='pb-1 text-smaller mrd-3' style={{ color: this.state.current == 'background' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "background" })} >
                                            <p className='text-semibold text-small'>{("Background")}</p>
                                        </div>
                                        <div className='pb-1 text-smaller' style={{ color: this.state.current == 'text' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "text" })} >
                                            <p className='text-semibold text-small'>{("Text")}</p>
                                        </div>
                                    </div>
                                    <ChromePicker color={this.props.data ? this.props.data[this.state.current] : '#fff'} onChange={this.handleChange} />
                                </div>
                            </div>
                        </>
                    </FixedView>
                </div>
            </div >
        )
    }
}

export default AdvancedColorInput;